import React from 'react';
import { Stack, Tooltip, Typography } from '@mui/material';

import { ListCard } from 'components/Card';
import { IconWrapper } from 'components/Icon';

import { DragHandle } from './DragHandle';
import { RowActions } from './RowActions';

export const LotListItem = ({
  name,
  description,
  all_suppliers,
  supplier_count,
  supplier_total,
  role_count,
  withSuppliers,
  canDrag,
  isDragged,
  dragHandlers,
  markForEdit,
  markForDelete,
  openSuppliers,
  openRoles,
}) => {
  return (
    <ListCard
      p={1.5}
      draggable={canDrag}
      aria-label={`Lot ${name}`}
      sx={{ opacity: isDragged ? 0.4 : 1, cursor: canDrag ? 'grab' : 'default' }}
      {...(canDrag && dragHandlers)}
    >
      <Stack direction="row" alignItems="center" flex={12} gap={1} minWidth={0} pl={1}>
        {canDrag && <DragHandle />}
        <Typography
          variant="body1"
          fontWeight={700}
          fontSize="1rem"
          noWrap
          sx={{ textDecoration: 'underline', cursor: 'pointer' }}
          onClick={markForEdit}
        >
          {name}
        </Typography>
        {description && (
          <Tooltip title={description}>
            <Stack aria-label={`Description of ${name}`}>
              <IconWrapper
                icon="info"
                sx={({ palette }) => ({
                  svg: { width: 20, height: 20, color: palette.grey[500] },
                })}
              />
            </Stack>
          </Tooltip>
        )}
      </Stack>

      {withSuppliers && (
        <Stack justifyContent="center" minWidth={100} pl={2}>
          <Typography variant="caption" fontWeight={700}>
            Suppliers
          </Typography>
          <Typography
            variant="body2"
            fontWeight={700}
            role="button"
            aria-label={`Suppliers of ${name}`}
            sx={{ textDecoration: 'underline', cursor: 'pointer' }}
            onClick={openSuppliers}
          >
            {all_suppliers ? 'All' : `${supplier_count} / ${supplier_total}`}
          </Typography>
        </Stack>
      )}

      <Stack direction="row" alignItems="center" flex={1} position="relative" minWidth={200} pl={2}>
        <Stack>
          <Typography variant="caption" fontWeight={700}>
            Roles
          </Typography>
          <Typography
            variant="body2"
            fontWeight={700}
            role="button"
            aria-label={`Roles of ${name}`}
            sx={{ textDecoration: 'underline', cursor: 'pointer' }}
            onClick={openRoles}
          >
            {role_count}
          </Typography>
        </Stack>

        <RowActions name={name} onEdit={markForEdit} onDelete={markForDelete} />
      </Stack>
    </ListCard>
  );
};
